// @ts-nocheck
import React, { createRef } from "react";
import SupportingFileProcess from "..";
import {
  handleUpdateReviseSortFile,
  reviseUpdateSortFilesFollowFileTag,
  flowCategoryId,
  actions,
} from "../../../publicDictionaryValues";
import NormalSpin from "../../../../base/basicComponents/spin";
import ApproveUpdateSupportingFilePending from "./approveUpdateSupportingFilePending";
import ApproveUpdateSupportingFileComplete from "./approveUpdateSupportingFileComplete";
import ReviseUpdateSupportingFilePending from "./reviseUpdateSupportingFilePending";
import ReviseUpdateSupportingFileComplete from "./reviseUpdateSupportingFileComplete";
import UpdateSupportingFileSubmitComplete from "./updateSupportingFileSubmitComplete";
import styles from "../style/index.module.scss";

const supportingRef = createRef();
const approvePageRef = createRef();
const supportingReplaceFileRef = createRef();
export default class UpdateSupportingFileProcess extends SupportingFileProcess {
  /* sort supporting files follow status in revise page */
  handleSortFile = (result: any) => {
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    const tiggerTimes = result.sequence;
    if (tiggerTimes > 1) {
      return handleUpdateReviseSortFile(
        result.supportingFolder.supportingFiles,
        this._formateDate,
        isRevise
      );
    }
    // @ts-ignore
    return reviseUpdateSortFilesFollowFileTag(
      result.supportingFolder.supportingFiles,
      this._formateDate
    );
  };

  handleUpdateSupportingFileProcessPageType = () => {
    const { procedureStepStatus } = this.state.pageState;

    // @ts-ignore
    this.isSubmitComplete =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes === 1;
    // @ts-ignore
    this.isApprovePending = !this.isRevisePage && procedureStepStatus === "Pending";
    // @ts-ignore
    this.isApproveComplete = !this.isRevisePage && procedureStepStatus === "Complete";
    // @ts-ignore
    this.isRevisePending =
      this.isRevisePage && procedureStepStatus === "Pending" && this.tiggerTimes > 1;
    // @ts-ignore
    this.isReviseComplete =
      this.isRevisePage && procedureStepStatus === "Complete" && this.tiggerTimes > 1;
  };

  handleUpdateSupportingFileProcessServerPathValue = () => {
    return this.state.serverPathSectionState !== undefined
      ? this.state.serverPathSectionState.serverPathValue
      : "";
  };

  handleUpdateSupportingFileProcessSavedInRadioValue = () => {
    return this.state.savedInSectionState !== undefined
      ? this.state.savedInSectionState.savedInRadioValue
      : null;
  };

  handleUpdateSupportingFileProcessNewRejectReason = () => {
    const { rejectReason } = this.state.pageState;

    return rejectReason;
  };

  handleUpdateSupportingFileProcessNewSupportingTableData = () => {
    const { supportingTableData } = this.state;
    return JSON.parse(JSON.stringify(supportingTableData));
  };

  handleUpdateSupportingFileProcessParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };
  };

  handleUpdateSupportingFileProcessPageProps = () => {
    const { procedureStatus, receiveDate, requestByName, rejectStatus, flowCategoryID } =
      this.state.pageState;
    let newRejectReason = this.handleUpdateSupportingFileProcessNewRejectReason();

    return {
      procedureStatus,
      receiveDate,
      requestByName,
      newRejectReason,
      rejectStatus,
      supportingReplaceFileRef,
      flowCategoryID,
    };
  };

  handleUpdateSupportingFileProcessSectionProps = () => {
    const { jbProcedureSavedIn } = this.state;
    const { taskInfoData, procedureInfoData, ppoList, fileTableData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList,
      fileTableData,
      jbProcedureSavedIn,
    };
  };

  handleUpdateSupportingFileProcessSubmitComplete = () => {
    const { isMount } = this.state;
    const { shareTaskData } = this.state;
    const serverPathValue = this.handleUpdateSupportingFileProcessServerPathValue();
    const savedInRadioValue = this.handleUpdateSupportingFileProcessSavedInRadioValue();
    const newSupportingTableData = this.handleUpdateSupportingFileProcessNewSupportingTableData();

    const isCopyPage =
      this.state.pageState.flowCategoryID &&
      this.state.pageState.flowCategoryID === flowCategoryId.copySupportingFile;

    return (
      // @ts-ignore
      <UpdateSupportingFileSubmitComplete
        params={this.handleUpdateSupportingFileProcessParams()}
        pageProps={this.handleUpdateSupportingFileProcessPageProps()}
        sectionProps={this.handleUpdateSupportingFileProcessSectionProps()}
        shareTaskData={shareTaskData}
        supportingRef={supportingRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        initSupportingTableData={[...(this as any).initSupportingTableData]}
        data={newSupportingTableData}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        isMount={isMount}
        isCopyPage={isCopyPage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleUpdateSupportingFileProcessApprovePending = () => {
    const { isMount } = this.state;
    const { shareTaskData } = this.state;
    const serverPathValue = this.handleUpdateSupportingFileProcessServerPathValue();
    const savedInRadioValue = this.handleUpdateSupportingFileProcessSavedInRadioValue();
    const newSupportingTableData = this.handleUpdateSupportingFileProcessNewSupportingTableData();

    return (
      // @ts-ignore
      <ApproveUpdateSupportingFilePending
        params={this.handleUpdateSupportingFileProcessParams()}
        pageProps={{
          ...this.handleUpdateSupportingFileProcessPageProps(),
          isDisableAll: false,
        }}
        sectionProps={this.handleUpdateSupportingFileProcessSectionProps()}
        shareTaskData={shareTaskData}
        supportingRef={supportingRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        initSupportingTableData={[...(this as any).initSupportingTableData]}
        data={newSupportingTableData}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        closePage={this.closePage}
        isMount={isMount}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleUpdateSupportingFileProcessApproveComplete = () => {
    const { isMount } = this.state;
    const { shareTaskData } = this.state;
    const serverPathValue = this.handleUpdateSupportingFileProcessServerPathValue();
    const savedInRadioValue = this.handleUpdateSupportingFileProcessSavedInRadioValue();
    const newSupportingTableData = this.handleUpdateSupportingFileProcessNewSupportingTableData();

    const isCopyPage =
      this.state.pageState.flowCategoryID &&
      this.state.pageState.flowCategoryID === flowCategoryId.copySupportingFile;

    // @ts-ignore
    const isRejectCompletePage = this.actionID === actions.reject;

    return (
      // @ts-ignore
      <ApproveUpdateSupportingFileComplete
        params={this.handleUpdateSupportingFileProcessParams()}
        pageProps={{
          ...this.handleUpdateSupportingFileProcessPageProps(),
          isDisableAll: true,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={this.handleUpdateSupportingFileProcessSectionProps()}
        shareTaskData={shareTaskData}
        supportingRef={supportingRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        initSupportingTableData={[...(this as any).initSupportingTableData]}
        data={newSupportingTableData}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        updateSupportingFileNum={this.updateSupportingFileNum}
        isMount={isMount}
        isCopyPage={isCopyPage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
        isRejectCompletePage={isRejectCompletePage}
      />
    );
  };

  handleUpdateSupportingFileProcessRevisePending = () => {
    const { isMount } = this.state;
    const { shareTaskData } = this.state;
    const serverPathValue = this.handleUpdateSupportingFileProcessServerPathValue();
    const savedInRadioValue = this.handleUpdateSupportingFileProcessSavedInRadioValue();
    const newSupportingTableData = this.handleUpdateSupportingFileProcessNewSupportingTableData();

    return (
      // @ts-ignore
      <ReviseUpdateSupportingFilePending
        params={this.handleUpdateSupportingFileProcessParams()}
        pageProps={{
          ...this.handleUpdateSupportingFileProcessPageProps(),
          // @ts-ignore
          actionID: this.actionID,
          isDisableAll: false,
        }}
        sectionProps={this.handleUpdateSupportingFileProcessSectionProps()}
        shareTaskData={shareTaskData}
        supportingRef={supportingRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        initSupportingTableData={[...(this as any).initSupportingTableData]}
        data={newSupportingTableData}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        handleReturnSubmitData={this.handleReturnSubmitData}
        closePage={this.closePage}
        updateSupportingFileNum={this.updateSupportingFileNum}
        isMount={isMount}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleUpdateSupportingFileProcessReviseComplete = () => {
    const { isMount } = this.state;
    const { shareTaskData } = this.state;
    const serverPathValue = this.handleUpdateSupportingFileProcessServerPathValue();
    const savedInRadioValue = this.handleUpdateSupportingFileProcessSavedInRadioValue();
    const newSupportingTableData = this.handleUpdateSupportingFileProcessNewSupportingTableData();

    const isCopyPage =
      this.state.pageState.flowCategoryID &&
      this.state.pageState.flowCategoryID === flowCategoryId.copySupportingFile;

    return (
      // @ts-ignore
      <ReviseUpdateSupportingFileComplete
        params={this.handleUpdateSupportingFileProcessParams()}
        pageProps={{
          ...this.handleUpdateSupportingFileProcessPageProps(),
          isDisableAll: true,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={this.handleUpdateSupportingFileProcessSectionProps()}
        shareTaskData={shareTaskData}
        supportingRef={supportingRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        initSupportingTableData={[...(this as any).initSupportingTableData]}
        data={newSupportingTableData}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        isMount={isMount}
        isCopyPage={isCopyPage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  render() {
    const { loading, supportingFileNum, uploadSupportingFileNum } = this.state.pageState;

    this.handleUpdateSupportingFileProcessPageType();

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          supportingFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadSupportingFileNum}/{supportingFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {/* @ts-ignore */}
            {this.isSubmitComplete && this.handleUpdateSupportingFileProcessSubmitComplete()}
            {/* @ts-ignore */}
            {this.isApprovePending && this.handleUpdateSupportingFileProcessApprovePending()}
            {/* @ts-ignore */}
            {this.isApproveComplete && this.handleUpdateSupportingFileProcessApproveComplete()}
            {/* @ts-ignore */}
            {this.isRevisePending && this.handleUpdateSupportingFileProcessRevisePending()}
            {/* @ts-ignore */}
            {this.isReviseComplete && this.handleUpdateSupportingFileProcessReviseComplete()}
          </>
        }
      />
    );
  }
}
